//libs
import React from 'react';

//api
import { useGetSpecialProjects } from 'api/special-progects/useGetSpecialProjects';

//styles
import { SliderUI, Wrap } from './style';

//components
import { SampleNextArrow, SamplePrevArrow } from 'modules/global/SampleArrows';
import { SpecialProjectCard } from 'modules/main/components/SpecialProjectCard';

//hooks
import { useProContext } from 'store/ProReducer/useProContext';

export const SpecialProjects = ({ settings = {}, ...props }: { settings?: any }) => {
  const { modulId } = useProContext();

  const { data: { items = [] } = {} } = useGetSpecialProjects({
    modulId,
  });

  const extSettings = {
    draggable: false,
    infinite: items > 2,
    slidesToShow: 3,
    slidesToScroll: 3,
    speed: 500,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1390,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 925,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 570,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    ...settings,
  };

  if (items <= 2) {
    return (
      <Wrap {...props}>
        {items.map((data = {}, i: number) => {
          return (
            <React.Fragment key={i}>
              <SpecialProjectCard data={data} />
            </React.Fragment>
          );
        })}
      </Wrap>
    );
  } else {
    return (
      <Wrap {...props}>
        <SliderUI {...extSettings}>
          {items.map((data = {}, i: any) => {
            return (
              <React.Fragment key={i}>
                <SpecialProjectCard data={data} />
              </React.Fragment>
            );
          })}
        </SliderUI>
      </Wrap>
    );
  }
};

export default SpecialProjects;
